// extracted by mini-css-extract-plugin
module.exports = {"shadow":"fab-button_shadow__S3RUS"};